module.exports = __webpack_public_path__ + "img/frases-abstract-artist-preview.c9c8ba4c.jpg";